import VueRouter from 'vue-router'
import routes from './routes'
import service from '@/service'

// import wx from 'weixin-js-sdk'
function beforeEach (to, from, next) {
  const { query: { code, state, flag, subscribe, ...originParams }, ...routProps } = to
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (state === 'loginSuccess' && !!code && !!flag) {
    localStorage.setItem('loginType', flag)
    service.getAccessToken(code).then(res => {
      // console.log('access_token', res.access_token)
      service.getUserinfoByAccessToken(res.access_token).then(rs => {
        next({ ...routProps, query: originParams })
      }).catch(() => {
        next({ ...routProps, query: originParams })
      })
    }).catch(() => {
      next({ ...routProps, query: originParams })
    })
  } else {
    next()
  }
}

function afterEach (to, from) {
  // const jsApiList = to.meta.jsApiList
  // if (window.__wxjs_is_wkwebview) { // IOS
  //   if (window.entryUrl === '' || window.entryUrl === undefined) {
  //     var url = window.location.origin + to.fullPath
  //     window.entryUrl = url
  //   }
  // } else { // 安卓
  //   window.entryUrl = `${window.location.origin}${to.fullPath}`
  // }
  // if (jsApiList) {
  //   const uri = process.env.VUE_APP_TITLE === 'production' ? '/' : '/api/'
  //   axios.get(`mall/v1/store/info${uri}`, {
  //   }).then(res => {
  //     const appid = res.data.data.appId
  //     axios.get(`${uri}wx-server/util/js/api/ticket`, {
  //       params: {
  //         appId: appid,
  //         url: window.entryUrl
  //       }
  //     }).then(res => {
  //       const data = res.data.data
  //       wx.config({
  //         debug: to.meta.isdebug ? to.meta.isdebug : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //         appId: appid, // 必填，公众号的唯一标识
  //         timestamp: data.timestamp, // 必填，生成签名的时间戳
  //         nonceStr: data.nonceStr, // 必填，生成签名的随机串
  //         signature: data.signature, // 必填，签名，见附录1
  //         jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //       })
  //       if (to.meta.isdebug) {
  //         wx.checkJsApi({
  //           jsApiList: jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
  //           success: res => {
  //             alert(JSON.stringify(res))
  //           }
  //         })
  //       }
  //     }).catch(res => {
  //     })
  //   }).catch(res => {
  //   })
  // }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_TITLE === 'dev' ? '/' : '/member-card-activity/',
  routes
})

router.beforeEach(beforeEach.bind(router))
router.afterEach(afterEach.bind(router))

export default router
